import {FC} from 'react'
import {useTranslation} from 'react-i18next'
import {AppButton} from '../AppButton/AppButton'

interface Props {
  isLoading: boolean
  onSubmit: () => void
}

export const SubmitButton: FC<Props> = ({isLoading, onSubmit}) => {
  const {t} = useTranslation()

  return (
    <div className='d-flex justify-content-end mt-5'>
      <AppButton variant='primary' text={t('Save')} isLoading={isLoading} onClick={onSubmit} />
    </div>
  )
}
